const Common = {
  //...app
  appVersion: '2.2.42',
  esalesAppVersion: '0.0.3',
  mobileWidth: 620,
  //Zebra Scanner width: 362px and height: 510px
};

export default Common;
